export type { Pitfall, PitfallFrontmatter, PitfallSeverity } from "./types.js";
export { PitfallCatalog } from "./catalog.js";
